<div *ngFor="let section of productChangeNoticeSections">
  <div class="mt-20">
    <h2>{{ section.title }}</h2>
  </div>
  <div class="notice-notif wd100">
    <div class="mb-10">
      <div class="col-sm-12 mb-10">
        <i class="fa fa-toolbox" style="float: left">&nbsp;</i>
        <strong [innerHTML]="section.body.split('\n')[0] | mdToHtml"></strong>
      </div>
      <div class="col-sm-12 mt-10">
        <small [innerHTML]="section.body.split('\n')[1]"></small>
      </div>

      <div class="row ms-0">
        <div class="col-sm-3" *ngFor="let tableHead of section.tHead">
          <strong>{{ tableHead }}</strong>
        </div>
      </div>

      <div class="row ms-0">
        <div class="col-sm-3" *ngFor="let tableBody of section.tBody">{{ tableBody }}</div>
      </div>
    </div>
  </div>
</div>
